module.exports = __webpack_public_path__ + "static/img/customer1-2.946d9c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneCasePage/customer1-2.png
// module id = liQ8
// module chunks = 0